<div class="response-adaptive-card" #containerRef></div>
